import { useEffect, useMemo } from "react";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import { buildProjectionRequestKey } from "@contexts/projects/projectionScope";
import ProjectionLoadState from "@components/dashboard/financialProjection/ProjectionLoadState";
import AccordionItem from "./AccordionItem";
import StepAccordion from "./StepAccordion";

const CellAccordion = ({ parent, parentLabel, filters, path = [], containerId }) => {

  const { activeProject, projectionLoads = {} } = useProjectContext();
  const { _id, cells = {} } = activeProject
  const { loadCells } = useProjectActions();
  const unitCells = useMemo(() => cells[parent], [cells, parent])
  const cellLoad = projectionLoads[buildProjectionRequestKey("cells", parent)]

  useEffect(() => {
    if (_id && !unitCells && !cellLoad) {
      loadCells(parent);
    }
  }, [_id, parent, unitCells, cellLoad, loadCells]);

  return (
    <>
      <ProjectionLoadState
        level="cells"
        parent={parent}
        parentLabel={parentLabel}
        isMissing={!unitCells}
        onRetry={() => loadCells(parent)}
        focusTargetId={containerId}
        showErrorCode
      />
      {unitCells?.map((item) => <AccordionItem
        key={item.wbs_code_id}
        item={item}
        type={"cell"}
        typeTitle={"Célula construtiva"}
        ChildAccordionComponent={StepAccordion}
        filters={filters}
        path={path}
      />)}
    </>
  )
}

export default CellAccordion;
